import React from "react";

// Compact, data-first stat tile used across the app.
export const StatTile = ({ icon: Icon, value, label, onClick, accent = "text-slate-400", testId, className = "", badge = 0 }) => {
  const Comp = onClick ? "button" : "div";
  return (
    <Comp
      onClick={onClick}
      data-testid={testId}
      className={`kn-card relative px-3 py-2.5 text-left w-full ${onClick ? "hover:ring-1 hover:ring-[#E63946]/30 transition-shadow" : ""} ${className}`}
    >
      {badge > 0 && (
        <span data-testid={testId ? `${testId}-badge` : undefined}
          className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full kn-gradient text-white text-[10px] font-extrabold flex items-center justify-center shadow">
          {badge > 9 ? "9+" : badge}
        </span>
      )}
      <div className="flex items-center gap-2.5">
        {Icon && <Icon className={`h-4 w-4 shrink-0 ${accent}`} />}
        <div className="min-w-0">
          <p className="text-lg font-extrabold text-slate-900 leading-none truncate">{value}</p>
          <p className="text-slate-500 text-xs mt-1 truncate">{label}</p>
        </div>
      </div>
    </Comp>
  );
};

export default StatTile;
